<template>
    <v-layout column align-center>
        <template v-if="!value">
            <state-request
                v-bind="{
                    value,
                    program,
                    employee,
                    employer,
                    isUserEmployee,
                    isUserEmployer,
                }"
                v-on="{
                    input,
                }"
            >
                <template #activator="{ attrs, on }">
                    <v-btn small outlined width="100" color="primary" v-bind="attrs" v-on="on">
                        <span> 면접요청 </span>
                    </v-btn>
                </template>
            </state-request>
        </template>

        <template v-else>
            <v-layout column align-center style="gap: 8px">
                <state-head
                    v-bind="{
                        value,
                        isUserEmployee,
                        isUserEmployer,
                    }"
                />
                <state-body
                    v-bind="{
                        value,
                        isUserEmployee,
                        isUserEmployer,
                    }"
                />
            </v-layout>
        </template>
    </v-layout>
</template>

<script>
import { initExpoProgram } from "@/assets/variables";
import StateBody from "./state/state-body.vue";
import StateHead from "./state/state-head.vue";
import StateRequest from "./state/state-request.vue";

export default {
    components: {
        StateBody,
        StateHead,
        StateRequest,
    },
    props: {
        value: { type: Object, default: null }, // matching
        program: { type: Object, default: initExpoProgram },
        employee: { type: Object, default: null },
        employer: { type: Object, default: null },
        isUserHost: { type: Boolean, default: false },
        isUserEmployee: { type: Boolean, default: false },
        isUserEmployer: { type: Boolean, default: false },
    },
    methods: {
        input(matching) {
            this.$emit("input", matching);
        },
    },
};
</script>

<style>
</style>